import React from 'react';
import { ThankYouContainer } from '../../atoms/thank-you-container/thank-you-container.atom';
import { Text } from '../../atoms/text/text.atom';

interface SuggestionItemProps {
  text: string;
}

export const SuggestionItem: React.FC<SuggestionItemProps> = ({ text }) => {
  return (
    <ThankYouContainer
      padding="0.5rem 0"
      style={{
        display: 'flex',
        alignItems: 'flex-start',
      }}
    >
      <div
        style={{
          width: '6px',
          height: '6px',
          borderRadius: '50%',
          backgroundColor: '#049366',
          margin: '0.5rem 0.75rem 0 0',
          flexShrink: 0,
        }}
      />
      <Text>{text}</Text>
    </ThankYouContainer>
  );
};